import React, {useEffect, useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {t} from 'react-switch-lang';
import BackBtn from './img/arrow-left.svg';
import './pageHeader.scss';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import {FormProvider, useForm} from 'react-hook-form';
import axios from 'axios';
import {BASE_URL, token} from '../../../utils/const';
import {externalizationStatuses} from '../../../utils/externalizationFormOptions';
import DownloadBtn from '../../reports/reportForm/components/downloadBtn/DownloadBtn';
import {useUserContext} from '../../../contexts/UserContext';
import roles from '../../../utils/roles';
const PageHeader = ({
  id,
  disabled,
  allowEdit,
  allowVerify,
  onEdit,
  onVerify,
  acceptButton,
  onAccept,
  onReject,
  requestForUpdateBtn,
  onRequestForUpdate,
  acceptRequestForUpdateBtn,
  onAcceptRequestForUpdate,
  onRejectRequestForUpdate,
  closeButton,
  onCloseRisk,
  riskClosingLoading,
  decideButton,
  onAcceptDecide,
  onRejectDecide,
  correctTab,
  url,
  deleteAllow,
  onDeleteRisk,
  requestForDelete,
  onRequestForDelete,
  acceptRejectDelete,
  onAcceptRequestForDelete,
  onRejectForDelete,
  defaultData,
  externalizationTitle,
  externalizationSubject,
  externalizationTin,
  externalizationCycle,
  externalizationId,
  onCycleChange,
  requestForDeleteExternalizationBtn,
  onRequestForDeleteExternalization,
  editExternalizationBtn,
  onEditExternalization,
  acceptRejectDeleteExternalization,
  onAcceptRequestForDeleteExternalization,
  onRejectForDeleteExternalization

}) => {
  const history = useHistory();
  let link = localStorage.getItem('previous_link');
  const [loadingUpdateAction, setLoadingUpdateAction] = useState(false);
  const [loadingVerifyAction,setLoadingVerifyAction] = useState(false);
  const methods = useForm();
  const { setValue, watch } = methods;
  const selectedCycle = watch("externalizationCycles");
  const [cyclesOptions, setCyclesOptions] = useState([]);
  const setIsSubmitted = React.useCallback(() => {}, []);
  const user = useUserContext()
  const handleAction = async (e, callback) => {
    e.preventDefault();
    if (loadingUpdateAction) return;
    try {
      setLoadingUpdateAction(true);
      await callback(e).then(() => {
        setLoadingUpdateAction(false);
      });
    } finally {
      setLoadingUpdateAction(false);
    }
  };
  useEffect(() => {
    if (!url.includes('externalizations')) return;
    if (!externalizationId) return;
    let mounted = true;

    const fetchCycles = async () => {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${BASE_URL}/externalizations/${externalizationId}/cycles`,
          headers: {
            Authorization: 'Bearer ' + token,
            Accept: '*/*',
          },
        });
        if (!mounted) return;
        let options = Array.isArray(data?.content)
          ? data?.content.map(item => {
            const statusItem = externalizationStatuses.find(s => s.value === item?.status);
            const translatedLabel = statusItem ? statusItem.label : item?.status;
            return {
              value: item?.id,
              label: item?.cycleNumber && (item?.status === 'REASSESSMENT_IN_PROGRESS' || item?.status === 'REASSESSMENT_COMPLETED')
                ? `${item?.cycleNumber}. ${translatedLabel}`
                : translatedLabel,
              raw: item,
            };
          })
          : [];
        setCyclesOptions(options);

        const defaultOption = options[0];
        setValue('externalizationCycles', defaultOption, { shouldValidate: true });

        if (onCycleChange) onCycleChange(defaultOption.value);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCycles();
    return () => {
      mounted = false;
    };
  }, [externalizationId]);

  useEffect(() => {
    if (selectedCycle?.value) {
      onCycleChange(selectedCycle.value, cyclesOptions);
    }
  }, [selectedCycle, onCycleChange]);
  return (
    <div className="page-header d-flex  align-items-center">
      <div className="col-6 p-0">
        <Link
          to={window.location.pathname}
          onClick={() => {
            if (window.location.pathname.includes('externalizations')) {
              history.go(-1);
            } else if (link !== null && link !== undefined) {
              window.location.pathname = link;
            } else {
              history.go(-1);
            }
          }}
          className="return-btn d-flex align-items-center"
        >
          <img src={BackBtn} alt="icon" />
          <span>
            {url.includes('incurred-risk')
              ? t('incurred-risk.page-header-show') +
                ' ID: ' +
                parseInt(id) +
                ' - ' +
                defaultData?.title
              : url.includes('potential-risk')
              ? t('common.potentialRiskTitle') +
                ' ID: ' +
                parseInt(id) +
                ' - ' +
                defaultData?.title
              : url.includes('externalizations') ?
                        <>
                          {t('externalization.subject')}: {externalizationSubject}<br />
                          {t('externalization.title')}: {externalizationTitle}<br />
                          {t('externalization.riskProponentForm.TIN')}: {externalizationTin}
                        </>
                        :  t('common.litigationRiskTitle') +
                ' ID: ' +
                defaultData?.id +
                ' - ' +
                defaultData?.risk.title}
          </span>
        </Link>

      </div>
      <div className="action-buttons d-flex align-items-center justify-content-end">
      {(
        externalizationCycle &&
        <div className="externalization-select">
          <FormProvider {...methods}>
            <form>
              <SelectInfinite
                key={cyclesOptions.length}
                name="externalizationCycles"
                options={cyclesOptions}
                valueKey="value"
                labelKey="label"
                selected={selectedCycle}
                isClearable={ false}
              />
              {(user?.authorities.includes(roles.role_risk_sector) ||
                  user.authorities.includes(roles.role_super_admin) ) &&
              <DownloadBtn
                className={'mb-5'}
                api={`reports/externalizations/${externalizationId}/full-report`}
                setIsSubmitted={setIsSubmitted}
                paramsLength={1}
                apiParameters={{cycleId: `cycleId=${selectedCycle?.value}`}}
                documentName={`PDF`}
              />}
            </form>
          </FormProvider>
      </div>        )}
        <div className=" buttons d-flex">
          {editExternalizationBtn && (
            <button
              className="btn primary-submit"
              disabled={loadingUpdateAction}
              onClick={(e) => {
                e.preventDefault();
                onEditExternalization()}}>
              {t('buttons.editBtn')}
            </button>
          )}
      {requestForDeleteExternalizationBtn && (
      <button className="btn primary-submit"
              disabled={loadingUpdateAction}
              onClick={(e) => handleAction(e,onRequestForDeleteExternalization)}
      >
        {t('buttons.requestForDelete')}
      </button>
      )}
      {acceptRejectDeleteExternalization && (
        <>
          <button
            className="btn primary-submit"
            onClick={(e) => handleAction(e,onAcceptRequestForDeleteExternalization)}
            disabled={loadingUpdateAction}
          >
            {t('buttons.onAcceptRequestForDeleteExternalization')}
          </button>

          <button
            className="btn primary-cancel"
            onClick={(e) => handleAction(e,onRejectForDeleteExternalization)}
            disabled={loadingUpdateAction}
          >
            {t('buttons.onRejectRequestForDeleteExternalization')}
          </button>
        </>
      )}
        </div>
      </div>
      {(url.includes('court-risk') ? (defaultData?.risk?.active === true) : (defaultData?.active === true)) &&
      <div className="col-6 p-0 d-flex align-items-center justify-content-end">

        {allowEdit &&
            !acceptRejectDelete &&
        disabled &&
        id !== undefined &&
        correctTab === 'details' &&
        !window.location.pathname.includes('edit') && (
          <button className="btn primary-submit"
                  disabled={loadingUpdateAction}
                  onClick={(e) => handleAction(e,onEdit)}
          >
            {t('buttons.changeBtn')}
          </button>
        )}
        {requestForUpdateBtn && id !== undefined && correctTab === 'details' && (
          <button
            className="btn primary-submit"
            disabled={loadingUpdateAction}
            onClick={(e) => handleAction(e,onRequestForUpdate)}
          >
            {t('buttons.requestToEdit')}
          </button>
        )}

        {closeButton && id !== undefined && correctTab === 'details' && (
          <button
            className="btn primary-submit"
            disabled={riskClosingLoading}
            onClick={(e) => handleAction(e,onCloseRisk)}
          >
            {t('buttons.closeRisk')}
          </button>
        )}

        {allowVerify && id !== undefined && correctTab === 'details' && (
          <button disabled={loadingVerifyAction} className="btn primary-submit ml-2"
                  onClick={(e) => onVerify(e)}>
            {t('buttons.verifyBtn')}
          </button>
        )}

        {acceptButton && id !== undefined && correctTab === 'details' && (
          <>
            <button className="btn primary-submit" onClick={(e) => onAccept(e)}>
              {t('buttons.accept')}
            </button>
            <button
              className="secondary-btn"
              type="reset"
              onClick={(e) => onReject(e)}
            >
              {t('buttons.refuse')}
            </button>
          </>
        )}

        {decideButton && id !== undefined && correctTab === 'details' && (
          <>
            <button
              className="btn primary-submit"
              onClick={(e) => onAcceptDecide(e)}
            >
              {t('buttons.acceptRiskSector')}
            </button>
            <button
              className="btn primary-cancel "
              type="reset"
              onClick={(e) => onRejectDecide(e)}
            >
              {t('buttons.rejectRiskSector')}
            </button>
          </>
        )}

        {acceptRequestForUpdateBtn &&
        id !== undefined &&
        correctTab === 'details' && (
          <>
            <button
              className="btn primary-submit"
              onClick={(e) => handleAction(e,onAcceptRequestForUpdate)}
              disabled={loadingUpdateAction}
            >
              {t('buttons.acceptUpdate')}
            </button>
            <button
              className="btn primary-cancel "
              type="reset"
              onClick={(e) => handleAction(e,onRejectRequestForUpdate)}
              disabled={loadingUpdateAction}
            >
              {t('buttons.refuseUpdate')}
            </button>
          </>
        )}
        {/*{deleteAllow && id !== undefined && correctTab === 'details' && (*/}
        {/*  <button*/}
        {/*    className="btn primary-cancel "*/}
        {/*    type="reset"*/}
        {/*    onClick={(e) => onDeleteRisk(e)}*/}
        {/*  >*/}
        {/*    {t('buttons.deleteBtnRisk')}*/}
        {/*  </button>*/}
        {/*)}*/}

        {/*{requestForDelete &&*/}
        {/*    !acceptRejectDelete &&*/}
        {/*id !== undefined &&*/}
        {/*correctTab === 'details' &&*/}
        {/*!url.includes('edit') && (*/}
        {/*  <button*/}
        {/*    className="btn primary-cancel"*/}
        {/*    onClick={(e) => handleAction(e,onRequestForDelete)}*/}
        {/*    disabled={loadingUpdateAction}*/}
        {/*  >*/}
        {/*    {t('buttons.requestForDelete')}*/}
        {/*  </button>*/}
        {/*)}*/}
        {/*{acceptRejectDelete && id !== undefined && correctTab === 'details' && (*/}
        {/*  <>*/}
        {/*    <button*/}
        {/*      className="btn primary-submit"*/}
        {/*      onClick={(e) => handleAction(e,onAcceptRequestForDelete)}*/}
        {/*      disabled={loadingUpdateAction}*/}
        {/*    >*/}
        {/*      {t('buttons.onAcceptRequestForDelete')}*/}
        {/*    </button>*/}

        {/*    <button*/}
        {/*      className="btn primary-cancel"*/}
        {/*      onClick={(e) => handleAction(e,onRejectForDelete)}*/}
        {/*      disabled={loadingUpdateAction}*/}
        {/*    >*/}
        {/*      {t('buttons.onRejectRequestForDelete')}*/}
        {/*    </button>*/}
        {/*  </>*/}
        {/*)}*/}
      </div>
      }
    </div>
  );
};

export default PageHeader;
